<template>
  <section id="cart-steps">
    <!-- Capacity sold -->

    <div class="empty-capacity">
      <img
        src="/img/icons/battery.svg"
        alt="Battery"
      >
      <h2>{{ $t("sold_capacity_title") }}</h2>
      <p>{{ $t("sold_capacity_text") }}</p>
    </div>

    <div class="inner">
      <Steps />
      <template v-if="isLoaded">
        <First v-if="step === 1 && shippings.length" />
        <Second v-if="step === 2" />
        <Third v-if="step === 3" />
        <Fourth v-if="step === 4" />
      </template>
    </div>
  </section>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex'
import { ref } from 'vue'
import First from './Steps/First.vue'
import Second from './Steps/Second.vue'
import Third from './Steps/Third.vue'
import Fourth from './Steps/Fourth.vue'
import Steps from './Partials/Steps.vue'
import useCart from './useCart'
import useProductService from '../../packages/views/product-service/useProductService'
import useOrderService from '../../packages/views/order-service/useOrderService'

export default {
  components: {
    Steps,
    Third,
    Second,
    First,
    Fourth,
  },
  props: {
    productServices: {
      type: String,
    },
    freeShippingLimit: {
      type: Object,
    },
    language: {
      type: Object,
    },
  },
  computed: {
    ...mapGetters({
      language: 'language/getCurrentLanguage',
      shippings: 'cart/getShippings',
      cartData: 'cart/getCartData',
      step: 'cart/getStep',
    }),
  },
  methods: {
    ...mapMutations('language', ['SET_CURRENT_LANGUAGE']),
  },
  setup(props) {
    const {
      setShippings,
      setPayments,
      getActualStep,
      updateCartStep,
      loadCartFromLocalStorage,
      setFreeShippingLimit,
      setLanguage,
    } = useCart()
    const { setOrderServices } = useOrderService()
    const { setProductServices } = useProductService()

    const actualStep = getActualStep()
    const isLoaded = ref(false)

    loadCartFromLocalStorage()

    setLanguage(props.language)

    setProductServices()

    setOrderServices()

    setPayments()

    setShippings()
    // free shipping limit
    setFreeShippingLimit(props.freeShippingLimit)

    if (actualStep !== null) {
      updateCartStep(actualStep)
    }

    isLoaded.value = true

    return {
      isLoaded,
    }
  },
}
</script>
